import { render, staticRenderFns } from "./ContentChip.vue?vue&type=template&id=64a32a4c"
import script from "./ContentChip.vue?vue&type=script&lang=js"
export * from "./ContentChip.vue?vue&type=script&lang=js"
import style0 from "./ContentChip.vue?vue&type=style&index=0&id=64a32a4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports